import { getIdServiceApi } from '@tempo-io/nexus-client';
import type { KyInstance } from 'ky';
import { getEnv } from '@/lib/utils/common/getEnv';
import { tempoApi } from '../tempoApi';

export const getIdApi = ({ client = tempoApi(undefined, false) }: { client?: KyInstance } = {}) =>
  getIdServiceApi({ client, prefixUrl: getEnv().apiBaseUrl });
